(function () {
  class PRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.setup();
    }

    disconnectedCallback() {
      this.teardown();
      this.initialized = false;
    }

    setup() {
      if (typeof Swiper === "undefined") return;

      this.swiperEl = this.querySelector("[data-recommendations-swiper]");
      this.paginationEl = this.querySelector("[data-recommendations-pagination]");
      if (!this.swiperEl) return;

      this.mobileMq = window.matchMedia("(max-width: 767px)");
      this.handleBreakpoint = this.handleBreakpoint.bind(this);
      this.mobileMq.addEventListener("change", this.handleBreakpoint);

      this.handleBreakpoint();
    }

    handleBreakpoint() {
      if (this.mobileMq.matches) {
        this.destroySwiper();
      } else {
        this.initSwiper();
      }
    }

    initSwiper() {
      if (this.swiperInstance) return;
      this.swiperInstance = new Swiper(this.swiperEl, {
        slidesPerView: 4,
        spaceBetween: 27,
        speed: 500,
        watchOverflow: true,
        pagination: {
          el: this.paginationEl,
          clickable: true
        },
        breakpoints: {
          768: {
            slidesPerView: 2.2,
            spaceBetween: 16
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 27
          }
        }
      });
    }

    destroySwiper() {
      if (!this.swiperInstance) return;
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }

    teardown() {
      this.destroySwiper();
      if (this.mobileMq && this.handleBreakpoint) {
        this.mobileMq.removeEventListener("change", this.handleBreakpoint);
      }
      this.mobileMq = null;
    }
  }

  if (!customElements.get("p-recommendations")) {
    customElements.define("p-recommendations", PRecommendations);
  }
})();
